import { cacheFetch } from '../../common/helpers/cacheFetchHelpers'
import {calendarNotificationHelper} from '../../calendar-common/helpers/calendarNotificationHelper'
import {notifySubscriptions} from '../../calendar-common/helpers/notifySubscriptionHelper'

const eventNotificationsReceived = (store, eventIds) => {
    const updated = Date.now()

    if(eventIds.length === 0){
        store.setState({ isFetching: false, fetchError: false, data: null, lastUpdated: updated })
        return true;
    }

    let eventResult = [];
    store.setState({ isFetching: true, fetchError: false, data: null, lastUpdated: updated })

    const config = store.getState().config;

    var totalResponse = 0
    let urlPrefix = `${config.calendarApiUrl}/${config.culture}/api/v1/events`

    const pushAndCheck = function(id,value){
        const { lastUpdated } = store.getState()
        if(lastUpdated > updated)
            return true;

        eventResult.push({
            id: id,
            checked: true,
            name: value.name,
            countryCode: value.countryCode,
            currencyCode: value.currencyCode,
            isVisible: true
        });
        if(totalResponse === eventIds.length)
        {
            store.setState({
                isFetching: false,
                fetchError: false,
                data: eventResult
            })
            return true;
        }
        return false;
    }

    eventIds.forEach(id => {
        let url = `${urlPrefix}/${id}`

        cacheFetch(url, false)
            .then(response => {
                totalResponse++;

                if (response.ok) {
                    response.json().then(value => {
                        if(pushAndCheck(id, value))
                            return
                    })
                }
            })
            .catch(err => {
                console.error(err)
                store.setState({ isFetching: false, fetchError: true, data: null, lastUpdated: updated })
                return
            })
    });
}

const getHelper = (store) => {
    const { config } = store.getState();

    return (config.notificationsHelper || calendarNotificationHelper)();
}

const enabledNotifications = (store) => {
    const { config } = store.getState();

    return (config.notificationsHelper || config.hasNotifications);
}

const subscriptionChangedListener = (store) => {
    const { config } = store.getState()
    if(config.subscriptionChangedEventName){
        document.addEventListener(config.subscriptionChangedEventName, function(e){
            eventNotificationsReceived(store, e.detail)
        }, false)
    }
}

const getEventNotifications = (store, helper) => {
    //helper.getSubscriptions().then(eventIds => eventNotificationsReceived(store, eventIds))
}

export const initEventNotifications = (store) => {
    if (!enabledNotifications(store))
        return;

    getHelper(store)
        .then(helper => {
                subscriptionChangedListener(store)

                if (helper.initSubscriptions) {
                    helper.initSubscriptions()
                        .then(() => getEventNotifications(store, helper))
                }
                else {
                    getEventNotifications(store, helper)
                }
            })
        .catch(err => console.error(err))
}

const toEvent = (store, eventIds, action) => {
    return new Promise((resolve, reject) => {
        if(!eventIds || !Array.isArray(eventIds) || eventIds.length === 0)
            return resolve();

        if (!enabledNotifications(store))
            return reject();

        var eventCount = 0

        getHelper(store)
            .then(helper => {
                helper.verifyPermision().then(
                    () => {
                        eventIds.forEach(eventId => {
                            action(helper, eventId)
                                .then(() => {
                                    eventCount++;
                                    if(eventCount === eventIds.length)
                                        return resolve();
                                })
                                .catch(err => {
                                    console.error(err)
                                    return reject();
                                })
                        })
                    }
                )
            })
    })
}

export const subscribeToEvent = (store, eventIds) => {
    const { config } = store.getState();
    return toEvent(store, eventIds,
        (helper, eventId) => helper.subscribe(eventId).then(eventTags => {
            notifySubscriptions(eventTags, config.subscriptionChangedEventName);
        })
        .catch(err => {
            console.error('Could not subscribe to event ' + eventId)
            console.error(err)
        }))
}

export const unsubscribeToEvent = (store, eventIds) => {
    const { config } = store.getState();
    return toEvent(store, eventIds,
        (helper, eventId) => helper.unsubscribe(eventId).then(eventTags => {
            notifySubscriptions(eventTags, config.subscriptionChangedEventName);
        })
        .catch(err => {
            console.error('Could not unsubscribe to event ' + eventId)
            console.error(err)
        }))
}
